module.exports = __webpack_public_path__ + "static/media/bike3-.a8b0229b.png";